import { render } from "./CrossTabMenu.vue?vue&type=template&id=5040c3eb&scoped=true"
import script from "./CrossTabMenu.vue?vue&type=script&lang=js"
export * from "./CrossTabMenu.vue?vue&type=script&lang=js"

import "./CrossTabMenu.vue?vue&type=style&index=0&id=5040c3eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5040c3eb"]])

export default __exports__